<template>
  <div class="invoice-info">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      title="发票信息"
      left-arrow
      @click-left="back"
      style="font-size: 12px; color: #333333;"
    />

    <!-- 所有信息内容 -->
    <div class="info-container">
      <!-- 乘车人信息 -->
      <div class="info-item">
        <div class="info-label">
          乘车人
        </div>
        <div class="info-content">
          <div>{{ passenger.name }}</div>
          <div>{{ passenger.ticketType }}</div>
        </div>
      </div>

      <!-- 行程信息 -->
      <div class="info-item">
        <div class="info-label">
          行程信息
        </div>
        <div class="info-content">
          <div>{{ trip.departure }} - {{ trip.arrival }}</div>
          <div>{{ trip.trainNumber }} {{ trip.carriage }} {{ trip.seat }}</div>
        </div>
      </div>

      <!-- 出行日期 -->
      <div class="info-item">
        <div class="info-label">
          出行日期
        </div>
        <div class="info-content">
          {{ trip.departureDate }} {{ trip.departureTime }}
        </div>
      </div>

      <!-- 原票票价 -->
      <div class="info-item">
        <div class="info-label">
          原票票价
        </div>
        <div class="info-content">
          ¥{{ ticket.originalPrice.toFixed(2) }}
        </div>
      </div>

      <!-- 发票项目 -->
      <!--      <div class="info-item">-->
      <!--        <div class="info-label">-->
      <!--          发票项目-->
      <!--        </div>-->
      <!--        <div class="info-content">-->
      <!--          {{ ticket.invoiceType }}-->
      <!--        </div>-->
      <!--      </div>-->

      <!-- 开票金额 -->
      <div class="info-item">
        <div class="info-label">
          开票金额
        </div>
        <div class="info-content">
          ¥{{ ticket.invoicePrice.toFixed(2) }}
        </div>
      </div>

      <!-- 发票类型 -->
      <div class="info-item">
        <div class="info-label">
          发票类型
        </div>
        <div class="info-content">
          电子发票(铁路电子客票)
        </div>
      </div>
    </div>

    <!-- 抬头类型、发票抬头、纳税人识别号 -->
    <div class="invoice-header-container">
      <!-- 抬头类型 -->
      <div class="invoice-header-item">
        <div class="invoice-header-label">
          抬头类型
        </div>
        <div class="invoice-header-content">
          <van-radio-group v-model="selectInvoiceHeader.invoiceType">
            <van-radio name="2">
              企业
            </van-radio>
            <van-radio name="1">
              个人/非企业
            </van-radio>
          </van-radio-group>
        </div>
      </div>

      <!-- 发票抬头 -->
      <div class="invoice-header-item">
        <div class="invoice-header-label">
          发票抬头
        </div>
        <div class="invoice-header-content">
          <van-field
            v-model="selectInvoiceHeader.title"
            placeholder="请输入发票抬头"
            readonly
          />
          <van-button type="info" size="small" @click="goToSelectInvoice">
            发票抬头
          </van-button>
        </div>
      </div>

      <!-- 纳税人识别号 -->
      <div class="invoice-header-item">
        <div class="invoice-header-label">
          纳税人识别号
        </div>
        <div class="invoice-header-content">
          <van-field
            v-model="selectInvoiceHeader.taxNumber"
            placeholder="请输入纳税人识别号"
          />
        </div>
      </div>
    </div>

    <!-- 温馨提示 -->
    <div class="tips">
      <div class="tips-title">
        温馨提示：
      </div>
      <div class="tips-content">
        请确认相关金额无异议，并准确完整填写发票抬头等信息；开具成功后，可通过铁路12306直接下载或通过邮件接收电子发票（铁路电子客票）。
      </div>
    </div>

    <!-- 提交按钮 -->
    <div class="submit-button">
      <van-button type="info" block @click="showConfirmPopup = true">
        提交
      </van-button>
    </div>

    <!-- 发票信息确认弹窗 -->
    <van-popup
      v-model="showConfirmPopup"
      position="center"
      :style="{ width: '90%', borderRadius: '8px' }"
    >
      <div class="confirm-popup">
        <div class="confirm-title">
          发票信息确认
        </div>

        <!-- 发票信息表格 -->
        <div class="confirm-table">
          <div class="confirm-row">
            <div class="confirm-label">
              发票类型
            </div>
            <div class="confirm-value">
              电子发票（铁路电子客票）
            </div>
          </div>
          <!--          <div class="confirm-row">-->
          <!--            <div class="confirm-label">-->
          <!--              发票项目-->
          <!--            </div>-->
          <!--            <div class="confirm-value">-->
          <!--              {{ ticket.invoiceType }}-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="confirm-row">
            <div class="confirm-label">
              发票金额
            </div>
            <div class="confirm-value">
              ¥{{ ticket.invoicePrice.toFixed(2) }}
            </div>
          </div>
          <div class="confirm-row">
            <div class="confirm-label">
              抬头类型
            </div>
            <div class="confirm-value">
              {{ selectInvoiceHeader.invoiceType == '2' ? '企业' : '个人/非企业' }}
            </div>
          </div>
          <div class="confirm-row">
            <div class="confirm-label">
              发票抬头
            </div>
            <div class="confirm-value">
              {{ selectInvoiceHeader.title }}
            </div>
          </div>
          <div class="confirm-row">
            <div class="confirm-label">
              纳税人识别号
            </div>
            <div class="confirm-value">
              {{ selectInvoiceHeader.taxNumber }}
            </div>
          </div>
        </div>

        <!-- 提示信息 -->
        <div class="confirm-tips">
          <div class="confirm-tips-item">
            * 电子发票开具后，将无法再为您提供纸质报销凭证。
          </div>
          <div class="confirm-tips-item">
            * 若需开车后改签车票且已开具电子发票，请到铁路车站窗口办理。
          </div>
          <div class="confirm-tips-item">
            请仔细核对发票信息，确认内容准确无误，若开票有误可换开一次。
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="confirm-buttons">
          <van-button type="default" block @click="showConfirmPopup = false">
            取消
          </van-button>
          <van-button type="info" block @click="handleConfirm">
            确认
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { NavBar, Radio, RadioGroup, Field, Button, Toast, Popup,Dialog  } from 'vant';
import { mapGetters } from 'vuex';

export default {
  name: 'openInvoiceDetail',
  components: {
    [NavBar.name]: NavBar,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Field.name]: Field,
    [Button.name]: Button,
    [Popup.name]: Popup,
  },
  created() {
    this.isOpen = this.$route.query.isOpen; // 从路由参数中获取 isOpen
    this.invoiceDetail = this.$route.query.invoiceDetail; // 从路由参数中获取 invoiceDetail 当前发票详情


    if (this.invoiceDetail.isInvoiceList){
      console.log('从发票列表组件传递的参数:，{}，{}', this.isOpen,this.invoiceDetail);
      //第一次创建初始化时将详情数据保存到vuex,保证数据准确，在存储下，防止信息不刷新
      this.$store.commit('invoice/invoiceDetail', this.invoiceDetail);
    }else {
      console.log('从其他组件传递的参数，无需存储:，{}，{}', this.isOpen,this.invoiceDetail);
    }


  },
  data() {
    return {
      // 模拟数据
      passenger: { name: '赵喜庆', ticketType: '成人票' },
      trip: {
        departure: '北京南',
        arrival: '菏泽东',
        trainNumber: 'G4803',
        carriage: '09车',
        seat: '04C号 一等座',
        departureDate: '2025-01-26',
        departureTime: '01:38开',
      },
      ticket: {
        originalPrice: '572',
        invoicePrice: '28.5',
        invoiceType: '退票费',
      },
      showConfirmPopup: false,
      isOpen: true,
      invoiceDetail: null
    };
  },
  computed: {
    ...mapGetters({
      selectInvoiceHeader: 'invoice/selectInvoiceHeader',
      trainsLoginInfo: 'tr/trSearchInfo',
      invoiceDetailVuex: 'invoice/invoiceDetail'
    }),
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    goToSelectInvoice() {
      this.$router.push('/userCenter/billInvoice/trainsInvoice/invoiceManagement');
    },
    handleConfirm() {

      this.showConfirmPopup = false;
      this.loginInfo = this.trainsLoginInfo['12306Info']
      this.invoiceDetail = this.invoiceDetailVuex

      if (this.selectInvoiceHeader.title == null || this.selectInvoiceHeader.title == '') {
        this.$dialog({
          message: "发票抬头不能为空"
        })
        return;
      }

      //开发票
      if (this.isOpen){
        //开发票
        var params = {
          username:this.loginInfo.trainAccount,
          password:this.loginInfo.password,
          ticketNumber:this.invoiceDetail.orderNumber,
          gmtDeparture: this.invoiceDetail.travelDate,
          invoiceHeader:this.selectInvoiceHeader.title,
          year:this.invoiceDetail.year,
          month:this.invoiceDetail.month,
          passengerInfo: {
            seatNo: this.invoiceDetail.invoiceDetail.passengerInfo.seatNo,
            coachNo: this.invoiceDetail.invoiceDetail.passengerInfo.coachNo,
          }
        }
        this.$api['trQuery/invoiceApply'](params).then(res => {
          //请求成功后跳转到列表页
          if(res.errCode == '1') {
            this.showConfirmDialog()
          } else if(res.errCode == '101' || res.errCode == '100') {
            console.log("invoiceApply 登录授权失败"+res.tips)
          } else {
            this.$dialog({
              message: res.errMsg
            })
            console.log("invoiceApply $dialog{}",err);
          }
        })


      }else {
        //换开发票
        var params = {
          username:this.loginInfo.trainAccount,
          password:this.loginInfo.password,
          ticketNumber:this.invoiceDetail.orderNumber,
          invoiceHeader:this.selectInvoiceHeader.title,
          year:this.invoiceDetail.year,
          month:this.invoiceDetail.month,
        }
        this.$api['trQuery/invoiceChangeHeader'](params).then(res => {
          //请求成功后跳转到列表页
          if(res.errCode == '1') {
            this.showConfirmDialog()
          } else if(res.errCode == '101' || res.errCode == '100') {
            console.log("invoiceChangeHeader 登录授权失败"+res.tips)
          } else {
            this.$dialog({
              message: res.errMsg
            })
            console.log("invoiceChangeHeader $dialog{}",err);
          }
        })

      }
    },
    showConfirmDialog() {
      Dialog.confirm({
        title: '确认',
        message: '提交成功,发票列表查看结果',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonColor: '#07c160',
        cancelButtonColor: '#ee0a24',
      })
        .then(() => {
          // 用户点击确认按钮
          console.log('用户点击了确认');
          // 在这里执行确认后的操作
          this.$router.push('/userCenter/billInvoice/trainsInvoice/openInvoiceList');
        })
        .catch(() => {
          // 用户点击取消按钮
          console.log('用户点击了取消');
          // 在这里执行取消后的操作
        });
    }
  },
  mounted() {
    if (this.invoiceDetailVuex) {
      console.log("invoiceDetailVuex{}",this.invoiceDetailVuex)
      this.isOpen = this.invoiceDetailVuex.isOpen;

      this.invoiceDetail = this.invoiceDetailVuex

      if (this.invoiceDetail){
        this.passenger.name = this.invoiceDetail.name;
        this.passenger.ticketType = '';//暂时先不展示

        this.trip.departure = this.invoiceDetail.departure;
        this.trip.arrival = this.invoiceDetail.arrival;
        this.trip.trainNumber = this.invoiceDetail.trainNumber;
        this.trip.carriage = '';
        this.trip.seat =  this.invoiceDetail.seatInfo;
        this.trip.departureDate =  this.invoiceDetail.travelDate;
        this.trip.departureTime =  this.invoiceDetail.invoiceDetail.depTime;

        this.ticket.originalPrice =  this.invoiceDetail.ticketPrice;
        this.ticket.invoicePrice =  this.invoiceDetail.amount;
        this.ticket.invoiceType =  '';//暂时先不展示

      }


    }
  }
};
</script>

<style scoped>
.invoice-info {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding: 16px;
}

.info-container,
.invoice-header-container,
.tips {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  margin-bottom: 16px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.info-content {
  font-size: 14px;
  color: #666;
  text-align: right;
}

.invoice-header-item {
  margin-bottom: 16px;
}

.invoice-header-item:last-child {
  margin-bottom: 0;
}

.invoice-header-label {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.invoice-header-content {
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 8px;
}

.van-radio-group {
  display: flex;
  gap: 16px;
}

.van-field {
  flex: 1;
}

.tips {
  font-size: 12px;
  color: #999;
}

.tips-title {
  font-weight: bold;
  margin-bottom: 8px;
}

.submit-button {
  margin-top: 24px;
}

.confirm-popup {
  padding: 16px;
}

.confirm-title {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
}

.confirm-table {
  margin-bottom: 16px;
}

.confirm-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.confirm-row:last-child {
  border-bottom: none;
}

.confirm-label {
  font-size: 14px;
  color: #333;
}

.confirm-value {
  font-size: 14px;
  color: #666;
}

.confirm-tips {
  margin-bottom: 16px;
}

.confirm-tips-item {
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
}

.confirm-buttons {
  display: flex;
  gap: 16px;
}

.confirm-buttons .van-button {
  flex: 1;
}
</style>
